import { Component, OnInit, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { AutomationTypes, AutomationViewGroup } from '@tokeet-frontend/automations'
import { AutomationsTableComponent } from '../automations-table/automations-table.component'
import { ReviewAutomationOverlayComponent } from './automation-overlay/review-automation-overlay.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-review-automations',
  templateUrl: './review-automations.component.html',
  styleUrls: ['./review-automations.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReviewAutomationsComponent implements OnInit {
  @ViewChild(AutomationsTableComponent) table: AutomationsTableComponent

  @Input() showActions = false
  @Input() viewType: 'list' | 'grid' = 'grid'
  type = AutomationTypes.Review
  constructor(private dialog: DialogService, private amplitudeService: AmplitudeService) {}

  ngOnInit(): void {
    this.amplitudeService.logEvent('review-automations-view')
  }

  onAdd() {
    this.amplitudeService.logEvent('review-automations-add')
    this.dialog.openDrawer(ReviewAutomationOverlayComponent, {
      panelClass: 'drawer-full-80',
    })
  }

  onEdit(automation: AutomationViewGroup) {
    this.amplitudeService.logEvent('review-automations-edit')
    this.dialog.openDrawer(ReviewAutomationOverlayComponent, {
      panelClass: 'drawer-full-80',
      data: {
        automationGroup: automation,
      },
    })
  }
  onDuplicate(automation: AutomationViewGroup) {
    this.amplitudeService.logEvent('review-automations-duplicate')
    this.dialog.openDrawer(ReviewAutomationOverlayComponent, {
      panelClass: 'drawer-full-80',
      data: {
        automationGroup: automation,
        duplicate: true,
      },
    })
  }
}
